export const categories = [
  {
    slug: 'dongzuo',
    name: '动作大片',
    icon: 'ri-film-line',
    description: '热血激燃的动作电影，震撼视觉体验',
    imageSeq: 'cat-action',
    imageQuery: 'Epic%20action%20movie%20scene%20with%20explosive%20cinematic%20lighting%2C%20dramatic%20composition%2C%20warm%20golden%20and%20dark%20tones%2C%20professional%20film%20photography%20style%2C%20intense%20atmosphere%2C%20clean%20background%20with%20subtle%20grain%20texture',
  },
  {
    slug: 'xiju',
    name: '喜剧搞笑',
    icon: 'ri-emotion-laugh-line',
    description: '轻松欢笑的喜剧佳作，放松心情首选',
    imageSeq: 'cat-comedy',
    imageQuery: 'Bright%20cheerful%20comedy%20scene%20with%20warm%20lighting%2C%20playful%20colorful%20atmosphere%2C%20cinematic%20composition%2C%20joyful%20vibrant%20tones%2C%20professional%20film%20photography%2C%20clean%20minimal%20background',
  },
  {
    slug: 'juqing',
    name: '剧情文艺',
    icon: 'ri-heart-line',
    description: '深刻感人的剧情故事，触动心灵之作',
    imageSeq: 'cat-drama',
    imageQuery: 'Emotional%20drama%20film%20scene%20with%20soft%20natural%20lighting%2C%20warm%20intimate%20atmosphere%2C%20cinematic%20depth%20of%20field%2C%20muted%20earthy%20tones%2C%20artistic%20film%20photography%2C%20gentle%20gradient%20background',
  },
  {
    slug: 'kehuan',
    name: '科幻奇幻',
    icon: 'ri-rocket-line',
    description: '脑洞大开的科幻世界，探索未知领域',
    imageSeq: 'cat-scifi',
    imageQuery: 'Futuristic%20sci-fi%20cinematic%20scene%20with%20neon%20accents%20and%20deep%20space%20atmosphere%2C%20dramatic%20lighting%2C%20cinematic%20composition%2C%20cool%20and%20warm%20contrast%20tones%2C%20professional%20film%20photography%2C%20clean%20gradient%20background',
  },
  {
    slug: 'jilu',
    name: '纪录纪实',
    icon: 'ri-camera-lens-line',
    description: '真实世界的精彩记录，开阔视野之窗',
    imageSeq: 'cat-doc',
    imageQuery: 'Documentary%20style%20cinematic%20scene%20with%20natural%20earthy%20lighting%2C%20authentic%20atmospheric%20composition%2C%20warm%20neutral%20tones%2C%20professional%20documentary%20photography%2C%20clean%20soft%20background%20with%20organic%20textures',
  },
  {
    slug: 'dongman',
    name: '动漫动画',
    icon: 'ri-palette-line',
    description: '精美绝伦的动画世界，视觉艺术盛宴',
    imageSeq: 'cat-anime',
    imageQuery: 'Beautiful%20anime%20art%20style%20cinematic%20scene%20with%20vibrant%20colors%20and%20soft%20lighting%2C%20artistic%20composition%2C%20warm%20pastel%20tones%2C%20professional%20animation%20art%20style%2C%20clean%20gradient%20background%20with%20dreamy%20atmosphere',
  },
];

export const hotVideos = [
  {
    id: 'v001',
    title: '星际穿越：超越时空的史诗之旅',
    category: '科幻奇幻',
    categorySlug: 'kehuan',
    duration: '2:49:32',
    views: '1280万',
    rating: 9.4,
    imageSeq: 'hot-v001',
    imageQuery: 'Epic%20space%20exploration%20cinematic%20scene%20with%20distant%20galaxy%20and%20starship%2C%20dramatic%20warm%20lighting%2C%20cinematic%20composition%2C%20deep%20space%20atmosphere%2C%20professional%20film%20photography%2C%20clean%20dark%20gradient%20background',
    description: '一部关于爱与时间的科幻巨制，诺兰导演巅峰之作。',
    date: '2026-07-20',
  },
  {
    id: 'v002',
    title: '功夫之王：龙争虎斗传奇',
    category: '动作大片',
    categorySlug: 'dongzuo',
    duration: '2:05:18',
    views: '960万',
    rating: 9.1,
    imageSeq: 'hot-v002',
    imageQuery: 'Martial%20arts%20action%20film%20cinematic%20scene%20with%20dynamic%20fight%20choreography%2C%20dramatic%20golden%20hour%20lighting%2C%20epic%20composition%2C%20warm%20intense%20tones%2C%20professional%20film%20photography%2C%20clean%20background',
    description: '经典武术动作片，展现东方武术的极致美学。',
    date: '2026-07-15',
  },
  {
    id: 'v003',
    title: '欢乐喜剧人：笑傲江湖',
    category: '喜剧搞笑',
    categorySlug: 'xiju',
    duration: '1:38:45',
    views: '850万',
    rating: 8.9,
    imageSeq: 'hot-v003',
    imageQuery: 'Bright%20funny%20comedy%20film%20cinematic%20scene%20with%20colorful%20set%20design%2C%20cheerful%20warm%20lighting%2C%20playful%20composition%2C%20vibrant%20joyful%20tones%2C%20professional%20film%20photography%2C%20clean%20light%20background',
    description: '爆笑喜剧大片，让你从头笑到尾停不下来。',
    date: '2026-07-10',
  },
  {
    id: 'v004',
    title: '深海奇缘：未知世界的探索',
    category: '纪录纪实',
    categorySlug: 'jilu',
    duration: '1:52:10',
    views: '720万',
    rating: 9.3,
    imageSeq: 'hot-v004',
    imageQuery: 'Deep%20ocean%20documentary%20cinematic%20scene%20with%20bioluminescent%20sea%20creatures%2C%20mysterious%20blue-green%20underwater%20lighting%2C%20epic%20wide%20composition%2C%20professional%20nature%20photography%2C%20clean%20dark%20aquatic%20background',
    description: '一部震撼人心的海洋纪录片，探索深海未知生物。',
    date: '2026-07-05',
  },
  {
    id: 'v005',
    title: '千与千寻：神隐少女的奇幻冒险',
    category: '动漫动画',
    categorySlug: 'dongman',
    duration: '2:05:00',
    views: '1580万',
    rating: 9.6,
    imageSeq: 'hot-v005',
    imageQuery: 'Studio%20Ghibli%20style%20animated%20cinematic%20scene%20with%20magical%20spirit%20world%2C%20soft%20warm%20golden%20lighting%2C%20dreamy%20composition%2C%20rich%20vibrant%20colors%2C%20artistic%20animation%20style%2C%20clean%20gradient%20background',
    description: '宫崎骏经典动画，一段关于成长与勇气的奇幻旅程。',
    date: '2026-06-28',
  },
  {
    id: 'v006',
    title: '山河故人：岁月里的温情记忆',
    category: '剧情文艺',
    categorySlug: 'juqing',
    duration: '2:11:23',
    views: '650万',
    rating: 9.0,
    imageSeq: 'hot-v006',
    imageQuery: 'Poetic%20drama%20film%20cinematic%20scene%20with%20nostalgic%20atmosphere%2C%20soft%20golden%20hour%20lighting%2C%20intimate%20composition%2C%20warm%20muted%20tones%2C%20artistic%20film%20photography%2C%20clean%20gentle%20background',
    description: '一部跨越数十年的情感史诗，讲述普通人的人生故事。',
    date: '2026-06-20',
  },
];

export const latestVideos = [
  {
    id: 'v007',
    title: '赛博朋克2077：边缘行者完整版',
    category: '动漫动画',
    categorySlug: 'dongman',
    duration: '1:45:30',
    views: '580万',
    rating: 9.2,
    imageSeq: 'lat-v007',
    imageQuery: 'Cyberpunk%20anime%20cinematic%20scene%20with%20neon%20city%20nightscape%2C%20dramatic%20contrast%20lighting%2C%20futuristic%20composition%2C%20vibrant%20neon%20and%20dark%20tones%2C%20professional%20animation%20art%2C%20clean%20dark%20gradient%20background',
    description: '夜之城的传奇故事，赛博朋克世界的极致视觉盛宴。',
    date: '2026-08-01',
    isNew: true,
  },
  {
    id: 'v008',
    title: '荒野猎人：绝境求生之路',
    category: '动作大片',
    categorySlug: 'dongzuo',
    duration: '2:36:15',
    views: '430万',
    rating: 8.8,
    imageSeq: 'lat-v008',
    imageQuery: 'Wilderness%20survival%20cinematic%20scene%20with%20snowy%20mountain%20landscape%2C%20cold%20natural%20lighting%2C%20epic%20wide%20composition%2C%20cool%20white%20and%20warm%20contrast%20tones%2C%20professional%20film%20photography%2C%20clean%20atmospheric%20background',
    description: '一个关于生存与复仇的震撼故事，荒野之中的极限挑战。',
    date: '2026-07-30',
    isNew: true,
  },
  {
    id: 'v009',
    title: '你好李焕英：温情母爱催泪巨制',
    category: '剧情文艺',
    categorySlug: 'juqing',
    duration: '2:08:00',
    views: '1120万',
    rating: 9.3,
    imageSeq: 'lat-v009',
    imageQuery: 'Heartwarming%20family%20drama%20cinematic%20scene%20with%20nostalgic%201980s%20Chinese%20setting%2C%20soft%20warm%20golden%20lighting%2C%20intimate%20composition%2C%20gentle%20vintage%20tones%2C%20professional%20film%20photography%2C%20clean%20warm%20background',
    description: '感动亿万观众的中国亲情电影，笑中带泪的温暖故事。',
    date: '2026-07-28',
    isNew: true,
  },
  {
    id: 'v010',
    title: '黑客帝国：矩阵重启',
    category: '科幻奇幻',
    categorySlug: 'kehuan',
    duration: '2:28:44',
    views: '890万',
    rating: 8.7,
    imageSeq: 'lat-v010',
    imageQuery: 'Futuristic%20digital%20matrix%20cinematic%20scene%20with%20green%20code%20rain%20effect%2C%20dramatic%20cyber%20lighting%2C%20dynamic%20composition%2C%20dark%20tech%20tones%2C%20professional%20film%20photography%2C%20clean%20dark%20background',
    description: '经典科幻系列最新力作，再次挑战你对现实的认知。',
    date: '2026-07-25',
    isNew: true,
  },
  {
    id: 'v011',
    title: '地球脉动第三季：生命奇迹',
    category: '纪录纪实',
    categorySlug: 'jilu',
    duration: '1:00:00',
    views: '350万',
    rating: 9.5,
    imageSeq: 'lat-v011',
    imageQuery: 'Nature%20wildlife%20documentary%20cinematic%20scene%20with%20diverse%20animal%20species%2C%20golden%20natural%20sunlight%2C%20epic%20landscape%20composition%2C%20rich%20vibrant%20natural%20tones%2C%20professional%20nature%20photography%2C%20clean%20atmospheric%20background',
    description: 'BBC顶级自然纪录片，展现地球上最壮观的生命奇迹。',
    date: '2026-07-22',
    isNew: true,
  },
  {
    id: 'v012',
    title: '夏洛特烦恼：爆笑穿越喜剧',
    category: '喜剧搞笑',
    categorySlug: 'xiju',
    duration: '1:44:20',
    views: '760万',
    rating: 9.0,
    imageSeq: 'lat-v012',
    imageQuery: 'Chinese%20comedy%20film%20cinematic%20scene%20with%20nostalgic%20school%20setting%2C%20bright%20cheerful%20lighting%2C%20funny%20dynamic%20composition%2C%20warm%20playful%20tones%2C%20professional%20film%20photography%2C%20clean%20light%20background',
    description: '经典国产喜剧，穿越回到学生时代的爆笑故事。',
    date: '2026-07-18',
    isNew: true,
  },
  {
    id: 'v013',
    title: '进击的巨人最终季完结篇',
    category: '动漫动画',
    categorySlug: 'dongman',
    duration: '1:30:00',
    views: '920万',
    rating: 9.4,
    imageSeq: 'lat-v013',
    imageQuery: 'Epic%20anime%20battle%20cinematic%20scene%20with%20massive%20titans%20and%20dramatic%20sky%2C%20intense%20warm%20lighting%2C%20dynamic%20composition%2C%20powerful%20dramatic%20tones%2C%20professional%20animation%20art%2C%20clean%20epic%20background',
    description: '现象级动画最终章，巨人与人类的终极对决。',
    date: '2026-07-15',
    isNew: true,
  },
  {
    id: 'v014',
    title: '我不是药神：现实主义力作',
    category: '剧情文艺',
    categorySlug: 'juqing',
    duration: '1:57:00',
    views: '1350万',
    rating: 9.5,
    imageSeq: 'lat-v014',
    imageQuery: 'Realistic%20Chinese%20drama%20cinematic%20scene%20with%20urban%20street%20setting%2C%20natural%20muted%20lighting%2C%20intimate%20street%20composition%2C%20warm%20earthy%20tones%2C%20professional%20film%20photography%2C%20clean%20urban%20background',
    description: '改变中国电影的现实主义杰作，引发社会深刻共鸣。',
    date: '2026-07-12',
  },
];

export const faqData = [
  {
    question: '爱液视频网站需要注册才能观看吗？',
    answer: '不需要注册！爱液视频网站上的大部分内容都可以免费在线观看，无需注册账号。我们致力于为用户提供最便捷的观看体验，让您随时随地畅享精选高清视频资源。部分独家内容可能需要简单注册，但完全免费。',
  },
  {
    question: '视频播放支持哪些清晰度？',
    answer: '爱液视频网站支持从标清到超高清多种清晰度选择，包括480P、720P、1080P以及4K超高清画质。系统会根据您的网络状况自动推荐最佳清晰度，您也可以手动切换。我们持续优化视频编码技术，确保在保证画质的同时提供流畅的播放体验。',
  },
  {
    question: '可以在手机上观看爱液视频吗？',
    answer: '当然可以！爱液视频网站采用响应式设计，完美适配手机、平板和电脑等各种设备。无论您使用iOS还是Android系统，只需通过浏览器访问我们的网站，即可享受和电脑端一样流畅的观影体验。我们还针对移动网络做了专门优化，节省流量的同时保证画质。',
  },
  {
    question: '网站上的视频内容多久更新一次？',
    answer: '我们的内容团队每天都会更新视频资源，确保您能看到最新、最热门的精选内容。热门分类每天更新，精品专题每周推送，大型片库月度扩充。关注我们的更新动态，精彩内容不会错过！',
  },
  {
    question: '如何找到我喜欢的视频类型？',
    answer: '您可以通过首页的分类导航快速定位感兴趣的视频类型，包括动作大片、喜剧搞笑、剧情文艺、科幻奇幻、纪录纪实和动漫动画等。此外，我们还提供智能搜索和个性化推荐功能，帮助您发现更多符合口味的精彩内容。',
  },
  {
    question: '视频加载慢或卡顿怎么办？',
    answer: '如果遇到播放卡顿，建议您：1）检查网络连接是否稳定；2）尝试降低视频清晰度；3）清除浏览器缓存后重试；4）切换至其他网络环境。我们的CDN加速网络覆盖全国，通常能保证流畅播放。如问题持续，欢迎联系客服反馈。',
  },
];